/**
 * A "portal" idea stolen from http://joecritchley.svbtle.com/portals-in-reactjs
 *
 * This component allows an element to be detached from the current react DOM node
 * meaning that you can position it in anyway you want without being restricted by
 * relative parent containers.
 *
 * Uses include: modals, tooltips etc.
 */

import React from 'react';
import ReactDOM from 'react-dom';

export default class Portal extends React.Component {
    componentWillUnmount() {
        this.unrenderLayer();

        if (!this.props.portal) {
            document.body.removeChild(this.target);
        }
    }

    componentDidUpdate() {
        this.renderLayer();
    }

    componentDidMount() {
        if (this.props.portal) {
            this.target = document.querySelector(this.props.portal);
        } else {
            this.target = document.createElement('div');
            this.target.setAttribute('data-portal', '');
            document.body.appendChild(this.target);
        }

        this.renderLayer();
    }

    renderLayer() {
        ReactDOM.unstable_renderSubtreeIntoContainer(this, this.props.children, this.target);
    }

    unrenderLayer() {
        ReactDOM.unmountComponentAtNode(this.target);
    }
    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./js/common/components/Portal.jsx